class AppHeader {

    constructor(){
        this.bindMobileMenuButton();
    }

    bindMobileMenuButton(){
        jQuery('[data-js-mobile-menu-toggle]').click(function(e){
            e.preventDefault();
            jQuery('body').toggleClass('mobile-menu-active');
            jQuery(this).find('.nav-burger').toggleClass('active');
        });
    }

}

export default AppHeader;